import React, { Component } from 'react';

import API from '../../../utils/API';
import { Modal, ModalBody, ModalFooter, ModalHeader, Input, Button, Row } from 'reactstrap';
import 'react-toggle/style.css';
import Toggle from 'react-toggle';

import InputField from '../../inputs/inputField.js';
import ToggleField from '../../inputs/toggleField.js';
import FieldModal from '../../modals/fieldModal';
import SelectField from '../../inputs/selectField';

const dataOptions = [
	{ value: 'Attendee', label: 'Attendees' },
	{ value: 'Session', label: 'Sessions' },
	{ value: 'Group', label: 'Groups' },
	{ value: 'Email', label: 'Emails' },
	{ value: 'Submission', label: 'Form Submissions' },
	/* { value: 'inventory', label: 'Inventory' },
	{ value: 'textMessages', label: 'Text Messages' },
	{ value: 'forms', label: 'Forms' },
	{ value: 'pages', label: 'Pages' },
	{ value: 'engagements', label: 'Engagement' }, */
];

class AddReportViewModal extends Component {
	constructor(props) {
		super(props);
		this.state = {
			submitting: false,
			selectedDataOption: "",
			selectedForm: "",
			name: '',
			useCurrentViewSettings: true,
			formOptions: [],
			requiredFields: {
				name: false,
				type: false,
				formId: false
			}
		};
	}

	saveNewView = () => {
		const { name, useCurrentViewSettings, requiredFields, selectedDataOption, selectedForm } = this.state;
		const { orgId, type, referenceCollection, referenceId } = this.props;
		const view = {
			name,
			type: selectedDataOption.value,
			referenceCollection: referenceCollection,
			referenceId: referenceId,
			toggledColumns: [],
		};

		if (selectedDataOption.value === 'Submission' && selectedForm && selectedForm.value) {
			view.formId = selectedForm.value;
		}
		let valid = true;


		Object.keys(requiredFields).forEach((key) => {
			if (key === 'formId' && selectedDataOption.value !== 'Submission') {
				requiredFields[key] = false;
				return;
			}

			let valueToCheck;
			if (key === 'name') {
				valueToCheck = name;
			} else if (key === 'type') {
				valueToCheck = selectedDataOption.value;
			} else if (key === 'formId') {
				valueToCheck = selectedForm && selectedForm.value;
			}

			if (!valueToCheck || valueToCheck === '') {
				requiredFields[key] = true;
				valid = false;
			} else {
				requiredFields[key] = false;
			}
		});
		if (valid) {

			view.filterLayers = [];
			view.columnsOrder = [];
						
			if (name != '') {
				this.setState({ submitting: true });
				API()
					.post(`/Organizations/${orgId}/views`, { ...view, reportId: this.props.reportId })
					.then((res) => {
						this.setState({ submitting: false, requiredFields: requiredFields });
						this.props.addView(res.data);
						this.props.toggle();
					})
					.catch((err) => {
						this.setState({ submitting: false });
						console.log(err);
					});
			}
		} else {
			this.setState({ requiredFields: requiredFields });
		}
	};

	formOptions = () => {
		const { forms } = this.props;
		if (forms && forms.length > 0) {
			return forms.map((form) => {
				return { value: form._id, label: form.name };
			});
		} else {
			return [];
		}
	}

	render() {
		const { isOpen, toggle } = this.props;
		const { submitting, name, useCurrentViewSettings, requiredFields, selectedDataOption, selectedForm } = this.state;
		return (
			<div>

				<FieldModal
					size="medium"
					isOpen={isOpen}
					modalTitle={"Add View To Report"}
					bodyHeaderText={'Please enter the information below to add new view.'}
					bodyDescription={''}
					overflowOff={true}
					bodyContent={() => {
						return (
							<>
								<SelectField label="Data Set"
									value={selectedDataOption}
									options={dataOptions}
									onChange={(e) => this.setState({ selectedDataOption: e })}
								/>
								{selectedDataOption.value === 'Submission' && (
									<SelectField
										value={selectedForm}
										label={'Select Form'}
										required={true}
										errorTrigger={requiredFields.formId}
										options={this.formOptions()}
										onChange={(e) => this.setState({ selectedForm: e })}
									/>
								)}
								<InputField
									value={name}
									label={'View Name'}
									required={true}
									errorTrigger={requiredFields.name}
									onChange={(e) => this.setState({ name: e.target.value })}
								/>
								{/* <ToggleField
									label="Use current view settings"
									checked={useCurrentViewSettings}
									icons={false}
									onChange={(e) => this.setState({ useCurrentViewSettings: !useCurrentViewSettings })}
								/> */}
							</>)
					}}
					toggle={toggle}
					actionButtonLabel={!submitting ? 'Submit' : 'Adding...'}
					actionButton={() => this.saveNewView()}
					actionButtonDisabled={submitting}

				></FieldModal>

			</div>

		);
	}
}

export default AddReportViewModal;
